export default {
    auth(to, from, next) {
        const token = sessionStorage.getItem('token');

        if (!token) {
            next('/login');
        }

        next();
    },
};
